/* eslint-disable @typescript-eslint/no-unused-vars */
import { getEchartTooltipString } from "@/pages/dashboard/components/EchartsTooltip";
import { IColumn } from "@/pages/dashboard/components/EchartsTooltip/type";
import { IFormatRule } from "@home/utils/dbDataFormat/_type";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import React from "react";

export const getCustomStudioVerticalLineTooltip = (params: any, options: any) => {
  const { nameHeader = '', gameList, metricNameMap, formatter, className } = options || {};
  const data = params?.map((item: { seriesName: any; value: any; cover: any; }) => {
    const gameInfo = gameList?.find((game: any) => game?.unified_edition_id === item?.seriesName);
    return {
      name: gameInfo?.name || "",
      value: item?.value,
      src: gameInfo?.cover,
      marker: item?.marker,
      data: item?.data?.value,
      scaleRate: item?.data?.scaleRate,
    };
  });

  const columns: IColumn[] = [
    {
      key: 'name',
      header: nameHeader,
      showIcon: false,
      render: (name, item, column, iconDom) => (
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="dbh-studio-benchamrk-game-marker" dangerouslySetInnerHTML={{ __html: item?.marker }} >
            </div>
            <div className="dbh-studio-benchamrk-game-img">
              <img src={item.src} style={{ width: 30, height: 30, marginRight: 6, borderRadius: 6 }} />
            </div>
            <div className="dbh-studio-benchamrk-game-text">{name}</div>
          </div>
        </div>
      ),
    },
    {
      key: 'value',
      header: metricNameMap?.[params?.[0]?.name] || '',
      align: 'right',
      render: (name, item, column, iconDom) => {
        const { value, scaleRate } = item;
        return (
          <div>{dataFormat({ value: value !== '' ? value / (scaleRate || 1) : '-', formatRule: formatter })}</div>
        );
      },
    },
  ];

  return getEchartTooltipString({ table: { columns, data, }, className });
};